<div *ngIf="type == 'entities'">
    <h2>Grafo de entidades</h2>
    <p>Muestran aquellas entidades relacionadas entre sí en el mismo contexto de información.</p>

    <ul style="list-style-type:disc; margin-left:30px">
        <li>
            <p>El tamaño de los nodos está determinado por la cantidad de apariciones de la entidad.</p>
        </li>
        <li>
            <p>Se establece una arista entre dos entidades si son mencionadas en el mismo párrafo.</p>
        </li>
        <li>
            <p>El grosor de las aristas depende de la cantidad de párrafos en los que aparezcan los nodos que conecta.
            </p>
        </li>
        <li>
            <p>No se muestran aquellos nodos que no estén relacionados con otros.</p>
        </li>
    </ul>
</div>

<div *ngIf="type == 'topics'">
    <h2>Grafo de tópicos</h2>
    <p>Muestra aquellos tópicos relacionados entre sí en el mismo contexto de información.</p>

    <ul style="list-style-type:disc; margin-left:30px">
        <li>
            <p>El tamaño de los nodos está determinado por la cantidad de apariciones del tópico.</p>
        </li>
        <li>
            <p>Se establece una arista entre dos tópicos si son mencionadas en párrafos continuos.</p>
        </li>
        <li>
            <p>El grosor de las aristas depende de la cantidad de párrafos en los que aparezcan los nodos que conecta.
            </p>
        </li>
    </ul>
</div>

<div>
    <p></p>
    <p>Puede utilizar las flechas del teclado (⌨) para mover el grafo hacia <b>arriba</b> (&#8593;)
        , <b>abajo</b> (&#8595;)
        , <b>izquierda</b> (&#8592;)
        y <b>derecha</b> (&#8594;)
        . Para
        aumentar o disminuir las dimensiones puede usar las teclas <b>PageUp</b> y <b>PageDown</b>.</p>
    <p>En caso de utilizar el mouse (🖰), puede arrastrar el grafo hacia la dirección deseada y la rueda de
        deslazamiento
        para aumentar o disminuir las dimensiones.</p>
</div>

<div class='graph-canvas' id="visNetwork" #visNetwork></div>
